import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const result = await login(email, password);
    
    if (result.success) {
      window.location.href = '/research'; // Force reload to get latest version
    } else {
      setError(result.error || 'Login failed');
    }
    
    setLoading(false);
  };

  return (
    <div style={{maxWidth: '400px', margin: '3rem auto', padding: '2rem', background: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
      <h1 style={{textAlign: 'center'}}>Login</h1>
      {error && <p style={{color: 'red', textAlign: 'center'}}>{error}</p>}
      
      <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
        <div>
          <label htmlFor="email" style={{display: 'block', marginBottom: '0.5rem'}}>Email</label>
          <input 
            type="email" 
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '4px'}}
          />
        </div>
        <div>
          <label htmlFor="password" style={{display: 'block', marginBottom: '0.5rem'}}>Password</label>
          <input 
            type="password" 
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '4px'}}
          />
        </div>
        
        <button 
          type="submit" 
          disabled={loading}
          style={{background: '#2e7d32', color: 'white', border: 'none', padding: '0.75rem', borderRadius: '4px', cursor: loading ? 'not-allowed' : 'pointer'}}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      
      <p style={{textAlign: 'center', marginTop: '1.5rem'}}>
        Don't have an account? <Link to="/register" style={{color: '#2e7d32'}}>Sign Up</Link>
      </p>
    </div>
  );
};

export default LoginPage;
